import Botao from './Botao';

export const AssistirMaisTardeBotao = Botao;
